import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { PackagingIdVersion } from '../entities/aggregate-evaluation-input-dto';
import { ComparePackagingUnitDto } from '../entities/compare-packaging-unit-dto';
import { catchError, Observable, of, throwError } from 'rxjs';
@Injectable({ providedIn: 'root' })
export class CompareApiService {

    stayOnPageIfErrorHeader: HttpHeaders; // if true, stay on page instead of going to error page
    emptyHeader: HttpHeaders;

    constructor(private http: HttpClient) {
      this.stayOnPageIfErrorHeader = new HttpHeaders({ stayOnPageIfError: 'true' });
      this.emptyHeader = new HttpHeaders();
    }

    public postPuComparisons(idversions:PackagingIdVersion[], stayOnPageIfError: boolean) : Observable<ComparePackagingUnitDto[] | string>  {
      const url = `${environment.webApiAddress}/api/compare/packaging-units`;
      return this.http.post<ComparePackagingUnitDto[]>(url,idversions,{ headers: stayOnPageIfError ? this.stayOnPageIfErrorHeader : this.emptyHeader }).pipe(catchError(this.handleError));
    }

    protected handleError(error: HttpErrorResponse) {
        if (error.status === 400) {
          console.error(`Backend returned code ${error.status}:`, error.error);
          return of(error.error)
        }
        return throwError(() => new Error('Something bad happened; please try again later.'));
      }

}
